import React, { useState, useEffect, useMemo } from 'react';
import FavoriteCard from './FavoriteCard';
import BuildingDetails from '../BuildingsPreview/BuildingDetails';
import styles from '../../styles/Dashboard/FavoriteBuildings.module.css';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL;

// Predefined color palette
const colorPalette = [
  '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
  '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50',
  '#8bc34a', '#cddc39', '#ffc107', '#ff9800', '#ff5722'
];

const FavoriteBuildings = ({ tenantUserId }) => {
  const [favorites, setFavorites] = useState({ myFavorites: [], groupFavorites: [] });
    const [selectedBuilding, setSelectedBuilding] = useState(null); // Added: for modal


  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/users/${tenantUserId}/favorite-buildings`);
        setFavorites({
          myFavorites: res.data.myFavorites || [],
          groupFavorites: res.data.groupFavorites || [],
        });
      } catch (error) {
        console.error('Failed to fetch favorites:', error);
      }
    };

    fetchFavorites();
  }, [tenantUserId]);

  // Dynamically generate userColors
  const userColors = useMemo(() => {
    const allUsers = new Set(['You']);
    favorites.groupFavorites.forEach(fav => allUsers.add(fav.LikedBy));

    const userColorMap = {};
    const availableColors = [...colorPalette];

    allUsers.forEach(user => {
      if (availableColors.length === 0) {
        // Recycle palette if users exceed colors
        availableColors.push(...colorPalette);
      }
      const randomIndex = Math.floor(Math.random() * availableColors.length);
      userColorMap[user] = availableColors.splice(randomIndex, 1)[0];
    });

    return userColorMap;
  }, [favorites]);

  const noFavoritesAtAll = favorites.myFavorites.length === 0 && favorites.groupFavorites.length === 0;
  
const handleCardClick = async (buildingID) => {
  try {
    // Step 1: Fetch building and unit details
    const [buildingRes, unitsRes] = await Promise.all([
      axios.get(`${API_BASE_URL}/properties/buildings/${buildingID}/details`),
      axios.get(`${API_BASE_URL}/properties/units/${buildingID}/details`)
    ]);

    const fullUnits = unitsRes.data.map(unit => ({
      ...unit,
      AvailabilityStatus: unit.Status || 'unknown',
      ImageGallery: unit.ImageGallery || [],
      SquareFeet: unit.SquareFeet || 0,
      OfferID: unit.OfferID || null
    }));

    let unitsWithStatuses = [...fullUnits];

    // Step 2: Fetch live availability statuses
    const statusRes = await axios.get(`${API_BASE_URL}/offers/status/all`);

    if (statusRes && statusRes.data) {
      const statusMap = new Map(statusRes.data.map(status => [status.OfferID, status]));

      // Step 3: Merge availability statuses into units
		unitsWithStatuses = unitsWithStatuses.map(unit => ({
		  ...unit,
		  AvailabilityStatus: statusMap.get(unit.OfferID)?.AvailabilityStatus ?? unit.AvailabilityStatus,
		  RentAmount: statusMap.get(unit.OfferID)?.RentAmount ?? unit.RentAmount
		}));


    }

    // Final: Set merged data to state
	
	console.log(unitsWithStatuses);
    setSelectedBuilding({ ...buildingRes.data, Units: unitsWithStatuses });

  } catch (error) {
    console.error('Failed to fetch building/unit details or statuses:', error);
  }
};


  // NEW FUNCTION: Close the details modal
  const handleCloseModal = () => setSelectedBuilding(null);

  return (
    <div className={styles.container}>
      <h2>Your Favorites</h2>

      {noFavoritesAtAll && (
        <p className={styles.noFavorites}>
          Favorited units from Apartment Search will display here.
        </p>
      )}

      {favorites.myFavorites.length > 0 && (
        <div className={styles.section}>
          <h3><span>⭐</span> My Favorites</h3>
          <div className={styles.cardContainer}>
            {favorites.myFavorites.map(unit => (
              <FavoriteCard
                key={unit.BuildingID}
                unit={{ ...unit, likedBy: ['You'] }}
                userColors={userColors}
				onClick={() => handleCardClick(unit.BuildingID)}
              />
            ))}
          </div>
        </div>
      )}

      {favorites.groupFavorites.length > 0 && (
        <div className={styles.section}>
          <h3><span>👥</span> Group Favorites</h3>
          <div className={styles.cardContainer}>
            {favorites.groupFavorites.map(unit => (
              <FavoriteCard
                key={unit.BuildingID}
                unit={{ ...unit, likedBy: [unit.LikedBy] }}
                userColors={userColors}
				onClick={() => handleCardClick(unit.BuildingID)}
              />
            ))}
          </div>
        </div>
      )}
	  
	  {selectedBuilding && (
        <BuildingDetails building={selectedBuilding} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default FavoriteBuildings;
